export default __webpack_public_path__ + "static/media/131.d62b4e15.webp";